import isArray from 'lodash.isarray'

export const Objects = {
  isArray,
}
